import React from 'react'
import {
  faSquareMinus,
  faSquarePlus,
} from '@fortawesome/free-regular-svg-icons'
import { StyledShowPageAccordionIconOld } from './ShowPageAccordions.styles'

export const ShowPageAccordionIconOld = ({
  isActive,
  isDisabled,
}: {
  isActive: boolean
  isDisabled?: boolean
}): JSX.Element => {
  return (
    <StyledShowPageAccordionIconOld
      icon={isActive ? faSquareMinus : faSquarePlus}
      disabled={isDisabled}
    />
  )
}
